export default __webpack_public_path__ + "cc8d76ef8591d02cda6b9b724ae688f6.png";